import React from "react";

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin, AppInsightsContext, AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";

const appInsightsConnectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTIONSTRING;

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: appInsightsConnectionString,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableCookiesUsage: true,
  },
});

appInsights.loadAppInsights();

export const AppInsightsProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <AppInsightsErrorBoundary appInsights={reactPlugin} onError={(error) => <div>Error: {error.message}</div>}>
        {React.isValidElement(children) ? children : <>{children}</>}
      </AppInsightsErrorBoundary>
    </AppInsightsContext.Provider>
  );
};

export { appInsights };
